export default __webpack_public_path__ + "static/media/Resource-Icons-Self-Care-Parents-transparent.3ba91f94.png";